import axios from 'axios';
/*
import AmplifyStore from '../store/store';
import { components, AmplifyEventBus } from 'aws-amplify-vue';
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';


AmplifyEventBus.$on('authState', async (state) => {
    if (state === 'signedOut'){
    } else if (state === 'signedIn') {
        token = AmplifyStore.state.user.signInUserSession.idToken.jwtToken;
    }
});
*/

export const HTTP = axios.create({
  baseURL: `https://cwxo41u99h.execute-api.eu-central-1.amazonaws.com/Prod/`
 //   ,
 // headers: {
 //   Authorization: 'Bearer ${token}'
 // }
})




// WEBPACK FOOTER //
// ./src/components/http-common.js